<template>
  <div id="app">
    <!-- 全局返回按钮：仅在有 meta.back 的页面显示，fixed 左上角，不占布局流 -->
    <div v-if="showBack" class="globalBackBtn" @click="goBack">
      <van-icon name="arrow-left" class="backIcon" />
      <span class="backText">返回</span>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    showBack() {
      return !!(this.$route && this.$route.meta && this.$route.meta.back);
    },
  },
  methods: {
    goBack() {
      // 证书页：精确返回该证书对应的项目详情页（支付跨微信跳转会打乱浏览器历史，
      // 不能用 history.go(-1)，否则会回到学校首页。用证书自身的 itemId 定位项目。）
      if (this.$route.name === "certificate") {
        const itemId = this.$route.query.itemId || "";
        if (itemId) {
          this.$router.push({ path: "/project/projectDetail", query: { id: itemId } });
        } else {
          this.$router.push("/allProject");
        }
        return;
      }
      // 其他页面：有历史则回上一页，否则兜底回项目列表，避免直接 deep-link 进来时跳出站点
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/allProject");
      }
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  outline: none;
  background: none;
  text-decoration: none;
}
.commonBox {
  height: 100vh;
  width: 100%;
  background-image: url(assets/login.jpg);
  background-size: 750rem 585rem;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
}

/* 全局返回按钮：#B22222 胶囊 + 白字「返回」+ 左箭头，左上角悬浮 */
.globalBackBtn {
  position: fixed;
  top: 22rem;
  left: 22rem;
  z-index: 999;
  display: flex;
  align-items: center;
  padding: 8rem 22rem;
  background-color: #b22222;
  border-radius: 30rem;
  line-height: 1;
  box-shadow: 0 2rem 8rem rgba(0, 0, 0, 0.18);
}
.globalBackBtn .backIcon {
  color: #fff;
  font-size: 28rem;
  margin-right: 6rem;
}
.globalBackBtn .backText {
  color: #fff;
  font-size: 26rem;
  letter-spacing: 2rem;
}
</style>
